function Footer() {
  return (
    <footer>
      COPYRIGHT &copy; 2022 <b>Funkies</b>. ALL RIGHTS RESERVED.
    </footer>
  );
}

export default Footer;
